import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

export const Layout: FC<LayoutProps> = ({ children, header, footer }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:rounded-control focus:bg-background focus:px-4 focus:py-3 focus:font-medium focus:text-foreground focus:shadow-lg focus:outline-2 focus:outline-primary'
            >
                Skip to content
            </a>

            {header}

            <main id='main' className='flex-1'>
                {children}
            </main>

            {footer}
        </div>
    )
}
